import * as cx from 'classnames';
import { SEARCH_IN_FORUM } from 'mk/autogenerated/translations/SearchPanel.45d0c4026fb7ee4706015c029a626c85'
import useEventCallback from 'mk2/hooks/useEventCallback';
import * as React from 'react';
import styles from './SearchPanel.mscss';

interface OwnProps {
    className?: string;
    onSubmit?(searchQuery: string);
}

type Props = OwnProps;

const SearchPanel: React.FunctionComponent<Props> = React.memo(({ className, onSubmit }) => {
    const [query, setQuery] = React.useState('');
    const onChange = useEventCallback(
        (event: React.FormEvent<HTMLInputElement>) => {
            setQuery(event.currentTarget.value);
        },
        [setQuery],
    );
    const onSubmitHandler = useEventCallback(
        (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            onSubmit(query);
        },
        [query, onSubmit],
    );

    return (
        <form className={cx(styles.SearchPanel, className)} onSubmit={onSubmitHandler}>
            <i className={cx('fa fa-search', styles.SearchPanel__icon)} />

            <input
                className={styles.SearchPanel__input}
                type="text"
                placeholder={SEARCH_IN_FORUM}
                onChange={onChange}
            />
        </form>
    );
});

SearchPanel.displayName = 'SearchPanel';

export default SearchPanel;
